import GameState from './gameState.js';
import MenuState from './menuState.js';
import PlayingState from './playingState.js';
import PausedState from './pausedState.js';
import GameOverState from './gameOverState.js';

export {
    GameState,
    MenuState,
    PlayingState,
    PausedState,
    GameOverState
};

// Also export as default object for convenience
export default {
    GameState,
    MenuState,
    PlayingState,
    PausedState,
    GameOverState
};